import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { NavigationService } from "../../../navigation/navigation.service";
import { AppServiceHelperService } from "../../../services/app-service-helper.service";
import { EventBusService } from "../../../services/event-bus.service";

/**
 * User dashboard service
 */
@Injectable({
  providedIn: 'root'
})

export class UserDashboardService {
  /**
   * Show project steps event
   */
  _showProjectStepsEvent: EventEmitter<any> = new EventEmitter<any>();

  /**
   * The route prefix for creating a new project with associated properties
   */
  private _createNewProjectWithAssociatedProperiesRoutePrefix = 'createNewProjectWithAssociatedProperties';

  /**
   * The route prefix for general tasks
   */
  private _generalTasksRoutePrefix = 'general/tasks';

  /**
   * The API for the Reflist Pollux
   */
  private _reflistApi = 'reflist/pollux';

  /**
   * Constructor
   * @param httpClient HttpClient
   */
  constructor(private eventBus: EventBusService,
    private httpClient: HttpClient,
    private navigationService: NavigationService,
    private appServiceHelper: AppServiceHelperService) { }

  /**
   * Gets steps for portfolio
   */
  getUserGeneralAssignments(): Observable<any[]> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.casemanagement.api', `${this._generalTasksRoutePrefix}`)).pipe(take(1));
  }

  /**
   * Approve general task
   * @param projectData Project data
   * @param comment Comment
   */
  approve(projectData: any, comment = '') {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.pixwintegration.capforce.api', `${this._createNewProjectWithAssociatedProperiesRoutePrefix}/create?taskId=${projectData.oid}&comment=${comment}&regionId=${projectData.regionId}`), projectData.capForceProject).pipe(
      map((data) => {
        if (!data.success) {
          alert("Failed to approve general task");
        }
        if (data.success) {
          this.navigationService.updatePendingTasksCount(1);
        }
        return data.success;
      })
    );
  }

  /**
   * Reject approvals
   * @param projectData Project data
   * @param comment Comment message
   * @param projectId Project Id
   */
  rejectApprovals(comment: any, projectData: any, projectId: any) {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.pixwintegration.capforce.api', `${this._createNewProjectWithAssociatedProperiesRoutePrefix}/reject?projectOpportunityId=${projectData?.projectOpportunityId}&requestId=${projectData?.capForceProject?.ProjectRequestId}&comment=${comment}&taskId=${projectData.oid}&projectId=${projectId}`)).pipe(
      map((data) => {
        if (!data.success) {
          alert("Failed to reject approve");
        }
        if (data.success) {
          this.navigationService.updatePendingTasksCount(1);
        }
        return true;
      })
    );
  }

  /**
 * Retrieves approval tasks
 * @param userId User Id
 */
  getApprovalTasks(userId: number): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.casemanagement.api', `${this._generalTasksRoutePrefix}/approval/tasks?userId=${userId}`)).pipe(take(1));
  }

  /**
  * Retrieves approval history for all tasks
  */
  getApprovalHistory(): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.casemanagement.api', `${this._generalTasksRoutePrefix}/approval/history`)).pipe(take(1));
  }

  /**
   * Get Property Details
   * @param propertyOpportunityId Property Opportunity Id
   * */
  getPropertyDetails(propertyOpportunityId: any): Observable<any[]> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.casemanagement.api', `${this._generalTasksRoutePrefix}/property/details?propertyOpportunityId=${propertyOpportunityId}`)).pipe(take(1));
  }

  /**
   * Close valuation event steps and tasks
   * @param valuationEventId Valuation event id
   */
  completeAllStepsAndTaskOfValuationEvent(valuationEventId: any): Observable<any> {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.casemanagement.api', `${this._generalTasksRoutePrefix}/completeStepsAndTasks?valuationEventId=${valuationEventId}`), null).pipe(
      map((data) => {
        if (!data.success) {
          alert("Failed to approve general task");
        }
        if (data.success) {
          this.navigationService.updatePendingTasksCount(1);
        }
        return data.success;
      })
    );
  }

  /**
   * Complete project steps
   * @param projectId Project Id
   */
  completeProjectSteps(projectId: any): Observable<any> {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.casemanagement.api', `${this._generalTasksRoutePrefix}/completeProjectSteps?projectId=${projectId}`), null).pipe(
      map((data) => {
        if (!data.success) {
          alert("Failed to approve general task");
        }
        if (data.success) {
          this.navigationService.updatePendingTasksCount(1);
        }
        return data.success;
      })
    );
  }

  /**
   * Show or hide data loader
   * @param state State
   * */
  displayDataLoader(state: boolean) {
    this.eventBus.broadcastEvent("dataLoader", {
      displayLoader: () => {
        return state;
      }
    });
  }
}
